var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5429 18.3062L16.7285 14.2207L20.1676 15.903L25.0302 11.2186",
    stroke: "#1A1B1D",
    strokeWidth: 1.46667,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.0097V22.0444C24 23.1245 23.1245 24 22.0444 24H9.95556C8.87553 24 8 23.1245 8 22.0444V9.95556C8 8.87553 8.87553 8 9.95556 8H17.5111",
    stroke: "#1A1B1D",
    strokeWidth: 1.46667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashflowIcon);
export default __webpack_public_path__ + "static/media/cashflow-icon.99815db7053ce0eb21b30356a38b40f1.svg";
export { ForwardRef as ReactComponent };